module.exports = __webpack_public_path__ + "img/sweggr.a59c63cf.png";